import { render, staticRenderFns } from "./EquityPool.vue?vue&type=template&id=72af39fe&scoped=true"
import script from "./EquityPool.vue?vue&type=script&lang=js"
export * from "./EquityPool.vue?vue&type=script&lang=js"
import style0 from "./EquityPool.vue?vue&type=style&index=0&id=72af39fe&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72af39fe",
  null
  
)

export default component.exports